export default "__VITE_ASSET__Bxv4U0y2__"